import {RegularButtonLight} from "./";
import styled from "styled-components";

export const LoadMoreButton = styled(RegularButtonLight)`
	margin-bottom: 30px;
`;
